export const instantAccessItems: string[] = [
  '10 complete digital PE volumes.',
  '600+ pages of practical teaching content.',
  '180 structured activities across Elementary and Secondary.',
  'Learning goals, teaching cues, and step-by-step instructions.',
  'Inclusive adaptations and safety considerations.',
  'Assessment, observation, and reflection tools.',
  'Printable planning resources.',
  '5 exclusive bonus resources.',
  'Instant digital access.',
]
